export const FeedbackRptConstants ={
    GETALL_REQUEST: 'FEEDBACK_GETALL_REQUEST',
    GETALL_SUCCESS: 'FEEDBACK_GETALL_SUCCESS',
    GETALL_FAILURE: 'FEEDBACK_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'FEEDBACK_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'FEEDBACK_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'FEEDBACK_GETEXPORT_FAILURE',

    CLOSURE_REQUEST: 'PRODUCTAUTHENTICATIONS_CLOSURE_REQUEST',
    CLOSURE_SUCCESS: 'PRODUCTAUTHENTICATIONS_CLOSURE_SUCCESS',
    CLOSURE_FAILURE: 'PRODUCTAUTHENTICATIONS_CLOSURE_FAILURE',

    REJECTION_REQUEST: 'PRODUCTAUTHENTICATIONS_REJECTION_REQUEST',
    REJECTION_SUCCESS: 'PRODUCTAUTHENTICATIONS_REJECTION_SUCCESS',
    REJECTION_FAILURE: 'PRODUCTAUTHENTICATIONS_REJECTION_FAILURE',


    ServiceReq_REQUEST: 'ServiceReq_GETALL_REQUEST',
    ServiceReq_SUCCESS: 'ServiceReq_GETALL_SUCCESS',
    ServiceReq_FAILURE: 'ServiceReq_GETALL_FAILURE',
    LOADING_REQUEST: 'LOADING_REQUEST',

    GETSERVICEAGENTLIST_REQUEST: 'SERVICEAGENT_SERVICEAGENTLIST_REQUEST',
    GETSERVICEAGENTLIST_SUCCESS: 'SERVICEAGENT_SERVICEAGENTLIST_SUCCESS',
    GETSERVICEAGENTLIST_FAILURE: 'SERVICEAGENT_SERVICEAGENTLIST_FAILURE',

}
